import { Injectable } from "@angular/core";
import { ClientStatus } from "app/server/enums/client-status.enum";
import { OfficeType } from "app/server/enums/office-type.enum";
import { ReportType } from "app/server/enums/report-type.enum";
import { UserRole } from "app/server/enums/user-role.enum";
import { ReportSubject } from "../../server/enums/report-subject.enum";
import { ReportEntryCategory } from "../../server/enums/report-entry-category.enum";

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: "root",
})
export class EnumDisplayService {
  constructor() {}

  getClientStatusDisplay(value: ClientStatus) {
    switch (value) {
      case ClientStatus.asylum:
        return "Asyl";
      case ClientStatus.firstInstance:
        return "1. Instanz";
      case ClientStatus.firstInstanceObjection:
        return "1. Instanz Einspruch";
      case ClientStatus.noRightOfResidence:
        return "Kein Bleiberecht";
      case ClientStatus.secondInstance:
        return "2. Instanz";
      case ClientStatus.secondInstanceObjection:
        return "2. Instanz Einspruch";
      case ClientStatus.subsidiaryProtection:
        return "Subsidiärer Schutz";
      case ClientStatus.expelled:
        return "Vertrieben";
    }
  }

  getOfficeTypeDisplay(value: OfficeType) {
    switch (value) {
      case OfficeType.GVS:
        return "GVS: Erwachsene";
      case OfficeType.umF:
        return "GVS: UmF";
      case OfficeType.KJH:
        return "GVS: KJH";
    }
  }

  getUserRoleDisplay(value: UserRole) {
    switch (value) {
      case UserRole.Admin:
        return "Administrator";
      case UserRole.Bueroleitung:
        return "Standortleitung";
      case UserRole.BueroMA:
        return "Betreuer:in";
    }
  }

  getReportTypeDisplay(value: ReportType) {
    switch (value) {
      case ReportType.Schicht:
        return "Schichtbericht";
      case ReportType.Wohnung:
        return "Wohnungsbericht";
      case ReportType.Verlaufsdokumentation:
        return "Verlaufsdokumentation";
    }
  }

  getReportSubjectDisplay(value: ReportSubject) {
    switch (value) {
      case ReportSubject.Fruehdienst:
        return "Frühdienst";
      case ReportSubject.Nachtdienst:
        return "Nachtdienst";
      case ReportSubject.Spaetdienst:
        return "Spätdienst";
      case ReportSubject.Verlaufsdokumentation:
        return "Verlaufsdokumentation";
    }
  }

  getReportEntryCategoryDisplay(value: ReportEntryCategory) {
    switch (value) {
      case ReportEntryCategory.Standard:
        return "Standard";
      case ReportEntryCategory.Gesundheit:
        return "Gesundheit";
      case ReportEntryCategory.Bildung:
        return "Bildung";
      case ReportEntryCategory.AsylUndIntegration:
        return "Asyl und Integration";
      case ReportEntryCategory.Freizeit:
        return "Freizeit";
      case ReportEntryCategory.PsychosozialeEntwicklung:
        return "Psychosoziale Entwicklung";
      case ReportEntryCategory.SoziooekonomischeEntwicklung:
        return "Sozioökonomische Entwicklung";
      case ReportEntryCategory.Umfeld:
        return "Familiäres Umfeld & soziale Kontakte";
    }
  }
}
